import stringUtils from '../../utils/stringUtils';
import productHelpers from '../product/productHelpers';
import {assetMapping, holderAssetMapping} from './iccMarketMappings';

export const getMediaId = (material, isHolderAsset, deviceType) => {
    if (!material) return null;

    try {
        const materialColor = material.materialColor;
        const isUseBrandDiff = productHelpers.isUseProductBrandDifferentiator(deviceType, materialColor);
        const color = isUseBrandDiff ? material.materialBrandDifferentiator || materialColor : materialColor;
        const mediaIdParts = [
            material.materialGroup || material.device_material_group,
            material.materialBrandFamily,
            material.materialModelNumber,
            color,
        ];

        const isValidParts = !mediaIdParts.some((x) => !x);

        if (!isValidParts) return null;

        const mediaName = mediaIdParts.join('_');

        return isHolderAsset ? holderAssetMapping(mediaName) : assetMapping(mediaName);
    } catch (e) {
        return null;
    }
};

export const getErrorMapping = (error) => {
    return {
        errorCode: stringUtils.toString(error?.outerErrorCode || error?.errorCode),
        errorMessage: stringUtils.toString(error?.outerErrorMessage || error?.errorMessage),
    };
};
